module.exports = __webpack_public_path__ + "img/banner-6.7fa38d98.jpg";